<!--
 * @Author: guoyu
 * @Date: 2020-09-10 20:08:56
 * @LastEditors: your name
 * @LastEditTime: 2021-05-10 17:25:08
 * @Description: 技能詳情
-->
<template>
  <div class="skill-info-container">
    <BaseInfo class="base-info" :skillInfo="skillInfo" :isSelf="isSelf" :min7Mode="min7Mode" @switchToVoice="$emit('switchToVoice')"></BaseInfo>
    <DescInfo :skillInfo="skillInfo" :isShow="isShow" :isSelf="isSelf" :sex="this.playerInfo.sex"></DescInfo>
    <CommentInfo :skillInfo="skillInfo" :playerInfo="playerInfo" :isSelf="isSelf"></CommentInfo>
  </div>
</template>
<script>
import BaseInfo from './base-info'
import DescInfo from './desc-info'
import CommentInfo from './comment-info'
export default {
  components: {
    BaseInfo,
    DescInfo,
    CommentInfo,
  },
  props: {
    skillInfo: {
      type: Object,
      default: ()=>{
        return {}
      }
    },    
    min7Mode: {
      type: Object,
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    },
    playerInfo: {
      type: Object,
      default: () => {
        return {
          playerSkillVoList:[]
        };
      }
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    isPlayer: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      currentIndex: 0,
      isPC: window.innerWidth > 600,
    };
  },
  computed: {
    currentInfo() {
      let obj = {}
      return Object.assign(obj, this.currentSkillInfo, {voiceChatList: this.playerInfo.voiceChatList})
    }
  },
};
</script>
<style lang="scss" scoped>
.base-info {
  margin-bottom: 16px;
}
@media screen and (max-width:599px) {
  .skill-info-container {
    width: 100vw;
  }
  .share-fix-bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 90px;
    background: white;
    display: flex;
    justify-content: center;
    padding-bottom: env(safe-area-inset-bottom);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  }
}
</style>
